import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "allocation-container"
};
const _hoisted_2 = {
  key: 0,
  class: "special-content-container"
};
const _hoisted_3 = {
  key: 1,
  class: "content-container"
};
const _hoisted_4 = {
  class: "transfer-role-container"
};
const _hoisted_5 = {
  class: "role-card"
};
const _hoisted_6 = {
  class: "nickname"
};
const _hoisted_7 = {
  class: "optional-role-side"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "nickname"
};
const _hoisted_10 = {
  class: "wealth-container"
};
const _hoisted_11 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_12 = {
  class: "prop-container"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "prop-content"
};
const _hoisted_15 = {
  class: "prop-name"
};
const _hoisted_16 = {
  key: 0,
  class: "pagination-container"
};
import { computed, onMounted, ref } from 'vue';
import { ElButton, ElIcon, ElImage, ElInputNumber, ElMessage, ElPagination, ElRow } from 'element-plus';
import { DArrowRight } from '@element-plus/icons-vue';
import { isAdminType, isUserType } from '@/tools/utils';
import { request } from '@/manager/net_manager';
import store from '@/store'; // pre-declaration

export default {
  __name: 'AssetAllocation',
  props: {
    roleId: {
      type: [String, Number, null],
      required: false,
      default: null
    }
  },
  emits: ['update', 'close'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const message = ref(null);
    const recipientId = ref(null);
    const point = ref(0.0);
    const dataArray = ref([]);
    const selectedProps = ref([]);
    const pagerCount = ref(5);
    const size = ref(20);
    const total = ref(0);
    const page = ref(0); // computed

    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4);
    const roleArray = computed(() => store.state.role_array ?? []);
    const recipientArray = computed(() => {
      if (!props.roleId) return [];
      return roleArray.value.filter(item => item['id'] !== props.roleId);
    });
    const investor = computed(() => {
      if (!props.roleId) return null;
      const buffer = roleArray.value.filter(item => item.id === props.roleId);
      if (buffer.length === 0) return null;
      return buffer[0];
    });
    const wealthPoint = computed(() => {
      if (!investor.value) return -Infinity;
      return parseFloat(investor.value['wealth_point']);
    }); // functions

    const getPropsData = () => {
      let parameters = {};
      parameters['role_id'] = props.roleId;
      parameters['page'] = page.value;
      parameters['size'] = size.value;
      request('props/role_props/transferable/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        dataArray.value = response.data.props;
        total.value = response.data.numbers;
      });
    };

    const getAssetPointDesc = (roleData, isCurrentRole = false) => {
      if (!roleData) return '';

      if (isCurrentRole) {
        if (point.value > 0) {
          return `${roleData['wealth_point']} -> ${(parseFloat(roleData['wealth_point']) - point.value).toFixed(1)}`;
        } else {
          return roleData['wealth_point'];
        }
      } else {
        if (point.value > 0 && roleData['id'] === recipientId.value) {
          return `${roleData['wealth_point']} -> ${(parseFloat(roleData['wealth_point']) + point.value).toFixed(1)}`;
        } else {
          return roleData['wealth_point'];
        }
      }
    };

    const wealthPointAdjust = () => {
      if (message.value) {
        message.value.close();
      }

      let parameters = {
        'role_id': props.roleId,
        'value': point.value.toFixed(1)
      };
      request('role/wealth_point/allocation/', parameters, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        } // console.log(JSON.stringify(response))


        message.value = ElMessage.success({
          message: '完成调整',
          duration: 1500
        });
        emits('update');
        emits('close');
      });
    };

    const wealthPointTransfer = () => {
      if (message.value) {
        message.value.close();
      }

      if (!recipientId.value) {
        message.value = ElMessage.error({
          message: '没有选择转移对象',
          duration: 1500
        });
        return;
      }

      let parameters = {
        'sender_id': props.roleId,
        'recipient_id': recipientId.value,
        'value': point.value.toFixed(1)
      };
      request('role/wealth_point/transfer/', parameters, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        } // console.log(JSON.stringify(response))


        message.value = ElMessage.success({
          message: '完成转移',
          duration: 1500
        });
        emits('update');
        emits('close');
      });
    };

    const rolePropsTransfer = () => {
      if (message.value) {
        message.value.close();
      }

      if (!recipientId.value) {
        message.value = ElMessage.error({
          message: '没有选择转移对象',
          duration: 1500
        });
        return;
      }

      let parameters = {
        'sender_id': props.roleId,
        'recipient_id': recipientId.value,
        'props': selectedProps.value
      };
      request('props/role_props/transfer/', parameters, 'POST').then(response => {
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        } // console.log(JSON.stringify(response))


        message.value = ElMessage.success({
          message: '完成转移',
          duration: 1500
        });
        emits('close');
      });
    };

    const handlePageChange = index => {
      page.value = index - 1;
      getPropsData();
    };

    const selectedProp = item => {
      if ([0, 1, 2].includes(item.status)) return;
      if (item.binding_type && item.binding_type.id === 2) return;
      const index = selectedProps.value.indexOf(item.id);

      if (index > -1) {
        selectedProps.value.splice(index, 1);
      } else {
        selectedProps.value.push(item.id);
      }
    }; // lifecycle


    onMounted(() => {
      if (props.roleId && isUserType(userType.value)) {
        getPropsData();
      }

      if (recipientArray.value.length > 0) {
        recipientId.value = recipientArray.value[0].id;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_slider = _resolveComponent("el-slider");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(isAdminType)(userType.value) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_unref(ElRow), {
        style: {
          "width": "50%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_slider, {
          modelValue: point.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => point.value = $event),
          min: -200.0,
          max: 200.0
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_unref(ElRow), null, {
        default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
          modelValue: point.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => point.value = $event),
          min: -200.0,
          max: 200.0,
          precision: 1,
          step: 0.1,
          placeholder: "资产点数"
        }, null, 8, ["modelValue"]), _createVNode(_unref(ElButton), {
          onClick: wealthPointAdjust
        }, {
          default: _withCtx(() => [_createTextVNode(" 执行点数变更（" + _toDisplayString(point.value.toFixed(1)) + "） ", 1)]),
          _: 1
        })]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_unref(ElRow), {
        style: {
          "justify-content": "center"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElImage), {
          src: investor.value.avatar,
          fit: "cover",
          draggable: "false"
        }, null, 8, ["src"])]),
        _: 1
      }), _createElementVNode("text", _hoisted_6, _toDisplayString(investor.value?.nickname), 1), _createElementVNode("text", {
        class: _normalizeClass(["asset-point", point.value > 0 ? 'transfer' : ''])
      }, " 持有 " + _toDisplayString(getAssetPointDesc(investor.value, true)) + " 资产点 ", 3)]), _createVNode(_unref(ElIcon), {
        size: 16
      }, {
        default: _withCtx(() => [_createVNode(_unref(DArrowRight))]),
        _: 1
      }), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recipientArray.value, item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.id,
          class: _normalizeClass(["role-card", recipientId.value === item.id ? 'recipient' : 'unselect']),
          onClick: $event => recipientId.value = item.id
        }, [_createVNode(_unref(ElImage), {
          src: item.avatar,
          fit: "cover",
          draggable: "false"
        }, null, 8, ["src"]), _createElementVNode("text", _hoisted_9, _toDisplayString(item.nickname), 1), _createElementVNode("text", {
          class: _normalizeClass(["asset-point", point.value > 0 && recipientId.value === item.id ? 'transfer' : ''])
        }, " 持有 " + _toDisplayString(getAssetPointDesc(item, false)) + " 资产点 ", 3)], 10, _hoisted_8);
      }), 128))])]), _cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "divider"
      }, null, -1)), _createElementVNode("div", _hoisted_10, [_cache[4] || (_cache[4] = _createElementVNode("text", {
        class: "tips",
        style: {
          "align-self": "flex-start"
        }
      }, " Tips：角色持有的资产点数上限为（200.0），尽管在\"资产转移\"时不会有溢出损失，但在\"演出结算\"、\"角色贸易\"时可能因溢出损失 ", -1)), _createVNode(_component_el_slider, {
        modelValue: point.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => point.value = $event),
        disabled: wealthPoint.value <= 0,
        min: 0,
        max: wealthPoint.value
      }, null, 8, ["modelValue", "disabled", "max"]), _createVNode(_unref(ElRow), {
        style: {
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElInputNumber), {
          modelValue: point.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => point.value = $event),
          min: 0,
          max: wealthPoint.value,
          precision: 1,
          step: 0.1,
          placeholder: "资产点数"
        }, null, 8, ["modelValue", "max"]), _createVNode(_unref(ElButton), {
          onClick: wealthPointTransfer,
          disabled: point.value <= 0.0
        }, {
          default: _withCtx(() => [_createTextVNode(" 执行点数变更（" + _toDisplayString(point.value.toFixed(1)) + "） ", 1)]),
          _: 1
        }, 8, ["disabled"])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_11, [_cache[6] || (_cache[6] = _createElementVNode("text", {
        class: "tips",
        style: {
          "margin-bottom": "16px"
        }
      }, " Tips：部分道具（角色绑定、舞台审查、交易进行中等）无法进行转移，将不会出现在列表中 ", -1)), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (item, key) => {
        return _openBlock(), _createElementBlock("div", {
          key: key,
          class: _normalizeClass(["prop-card", selectedProps.value.includes(item.id) ? 'selected-prop-card' : '']),
          onClick: $event => selectedProp(item)
        }, [_createElementVNode("text", _hoisted_14, [_createTextVNode(_toDisplayString(item.type.desc) + " / " + _toDisplayString(item.tag.desc) + " ", 1), _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)), _createElementVNode("span", _hoisted_15, _toDisplayString(item.name) + " " + _toDisplayString(item.type.is_stackable ? ` * ${item.times}` : ''), 1)])], 10, _hoisted_13);
      }), 128))]), total.value > size.value ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_unref(ElPagination), {
        "page-size": size.value,
        "pager-count": pagerCount.value,
        layout: "prev, pager, next",
        total: total.value,
        background: true,
        onChange: handlePageChange
      }, null, 8, ["page-size", "pager-count", "total"])])) : _createCommentVNode("", true)]), _createVNode(_unref(ElRow), {
        style: {
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElButton), {
          onClick: rolePropsTransfer,
          disabled: selectedProps.value.length === 0
        }, {
          default: _withCtx(() => [_createTextVNode(" 执行道具变更（" + _toDisplayString(selectedProps.value.length) + "） ", 1)]),
          _: 1
        }, 8, ["disabled"])]),
        _: 1
      })]))]);
    };
  }

};